import React from 'react';
import Button from './Button';
import Icon from '../Icons/Icon';

const CloseButton = ({ ...props }) => (
  <Button {...props} classes="close-btn icon icon-M" faux>
    <Icon name="close" size="m" fill="black" />
    <span className="sr-only">Close</span>
  </Button>
);

export default CloseButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/CloseButton.js